export { default } from './FacebookIcon';
